import { pgTable, serial, text, integer, timestamp, jsonb } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const quoteRequestsTable = pgTable("quote_requests", {
  id: serial("id").primaryKey(),
  tenderId: integer("tender_id"),
  buyerUserId: integer("buyer_user_id").notNull(),
  vendorId: integer("vendor_id").notNull(),
  subject: text("subject").notNull(),
  message: text("message"),
  items: jsonb("items").$type<Array<{ name: string; qty: number; unit?: string }>>().notNull().default([]),
  status: text("status", { enum: ["pending", "responded", "accepted", "declined", "cancelled"] }).notNull().default("pending"),
  vendorResponse: text("vendor_response"),
  quotedPrice: text("quoted_price"),
  validUntil: timestamp("valid_until"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
});

export const insertQuoteRequestSchema = createInsertSchema(quoteRequestsTable).omit({ id: true, createdAt: true, updatedAt: true });
export type InsertQuoteRequest = z.infer<typeof insertQuoteRequestSchema>;
export type QuoteRequest = typeof quoteRequestsTable.$inferSelect;
